import styled from '@emotion/styled'
import _ from 'lodash'
import {
  IntegrationFormManager,
  IntegrationFormField,
  IntegrationNameBuilder,
  AccountSelectionBuilder,
  DataSelectionBuilder,
  FieldMappingBuilder,
} from '../components'
import { DataSelectionOptions } from './components'
import {
  DATA_TYPE_KEY,
  FILE_ASSETS_AEM_DATA_TYPE_KEY,
} from '../adobe-experience-manager-inbound/components'

const FullWidth = styled.div`
  width: 100%;
`

export function AdobeExperienceManagerOutbound({ assignment }) {
  const assignmentMetaDataType = assignment.metadata[DATA_TYPE_KEY] || FILE_ASSETS_AEM_DATA_TYPE_KEY

  const integrationNameField = new IntegrationNameBuilder().placement(1).build()
  const accountSelectionField = new AccountSelectionBuilder()
    .placement(2)
    .resetOnChange(true)
    .dataType(assignmentMetaDataType)
    .build()
  const dataSelectionField = new DataSelectionBuilder()
    .placement(3)
    .dataOptions(DataSelectionOptions)
    .defaultValue(FILE_ASSETS_AEM_DATA_TYPE_KEY)
    .metadataKey(DATA_TYPE_KEY)
    .resetIntegrationOnChange(true)
    .filtersToReset([])
    .build()
  const fieldMapping = new FieldMappingBuilder()
    .placement(4)
    .integrationTitle('AEM')
    .mappingType('outbound')
    .includeCreativeClassification(true)
    .build()

  const AEMOutboundFormFields: IntegrationFormField[] = [
    integrationNameField,
    accountSelectionField,
    dataSelectionField,
    fieldMapping,
  ]

  return (
    <FullWidth>
      <IntegrationFormManager
        integrationType="adobe-experience-manager-outbound"
        integrationAssignment={assignment}
        assignmentMetaDataType={assignmentMetaDataType}
        integrationFields={AEMOutboundFormFields}
      />
    </FullWidth>
  )
}
